export default __webpack_public_path__ + "static/media/jollof1.00712dd7.jpg";